import { ControlledSwitch, Help, useFormContainerContext } from '@if/mui'
import { Stack, Typography } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CustomBuydownFormValues } from '../customBuydown-schema'

export const OwnershipSwitch = () => {
  const { t } = useTranslation()
  const { methods } = useFormContainerContext<CustomBuydownFormValues>()
  const owned = useWatch({ control: methods.control, name: 'ownedByBanner' }) ?? false

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <ControlledSwitch control={methods.control} name="ownedByBanner" label={t('customBuydown.ownership.label')} />
        <Help title={t('customBuydown.ownership.tooltip')} />
      </Stack>
      <Typography variant="caption" color="text.secondary">
        {t(owned ? 'customBuydown.ownership.onHelper' : 'customBuydown.ownership.offHelper')}
      </Typography>
    </Stack>
  )
}
